<template>
    <div class="content">
        <global-tag>
            <span slot="title">惠老政策</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="政策类别：">
                                        <el-select
                                            v-model="queryInfo.policyCategoryId"
                                            placeholder="请选择"
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="item in orgList"
                                                :key="item.policyCategoryId"
                                                :label="item.policyCategoryName"
                                                :value="item.policyCategoryId"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label="咨询标题：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.title"
                                            style="width: 100%"
                                            placeholder="请输入机构养老点名称"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch" class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                    icon="el-icon-plus"
            class="openBtns"
                    @click="handleTableForm('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    class="button"
                    
                    @click="manageVersion"
                    >管理类别</el-button
                >
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                         class="dropRests"
                        @click="clearData"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="咨询标题"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="状态"></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="政策类别"
                    align="center"
                    prop="policyCategoryName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '政策类别'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="咨询标题"
                    align="center"
                    prop="title"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '咨询标题'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建时间"
                    align="center"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="状态"
                    align="center"
                    prop="status"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="0"
                            inactive-color="#ff4949"
                            active-color="#13ce66"
                            @change="changeStatic($event, scope.row)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    width="200px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span
                            @click="handleTableForm('查看', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >查看</span
                        >
                        <span
                            @click="handleTableForm('编辑', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >编辑</span
                        >
                        <span
                            @click="deleteItem(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >删除</span
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <add-address
            v-if="addressSate"
            :openData="addressInfo"
            :typeData="tableData"
            @cancleAddress="cancleAddress"
        ></add-address>
        <manage-open
            v-if="manageState"
            :openData="manageInfo"
            @cancleAddress="cancleAddress"
        ></manage-open>
    </div>
</template>
<script>
import addAddress from "./components/addAddress.vue"
import manageOpen from "./components/manageOpen.vue"
import globalTag from "../../components/globalTag"
import request from "@/utils/request.js"
export default {
    inject: ["reload"], //注入
    components: { addAddress, globalTag, manageOpen },
    data() {
        return {
            orgList: [],
            manageState: false,
            manageInfo: {},
            addressSate: false,
            addressInfo: {},
            queryInfo: {},
            showAddStatus: false,
            personIdCard: "",
            isSearchContent: false,
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            tableData: [],
            dialogVisible: false, //人员编辑
            dialogInfo: {},
            personState: false, //新增人员
            personInfo: {},
            radioId: "",
            tempTableChekbox: [
                "序号",
                "政策类别",
                "咨询标题",
                "创建时间",
                "状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "政策类别",
                "咨询标题",
                "创建时间",
                "状态",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
        this.getRecommendPeopleList()
    },
    methods: {
        cancleAddress(data) {
            this.manageState = false
            this.addressSate = false
            if (data == true) {
                this.getList()
            }
        },
        // 搜索
        querySearch() {
            this.getList()
        },
        // 关闭人员信息弹窗
        cancleOpen() {
            this.dialogInfo = {}
            this.dialogVisible = false
            // this.tableData = [];
            this.getList()
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/careOldPolicy/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            this.getList()
                        }
                    })
            })
        },
        changeStatic(e, data) {
            let status = ""
            if (e == 0) {
                status = 0
            } else {
                status = 1
            }
            request({
                url: "/ypt/admin/careOldPolicy/info/save",
                method: "POST",
                data: {
                    id: data.id,
                    status: status,
                },
            }).then((res) => {
                if (res.code == 200) {
                    this.getList()
                }
            })
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //重置
        clearData() {
            this.reload()
        },

        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                title: this.queryInfo.title,
                policyCategoryId: this.queryInfo.policyCategoryId,
            }
            this.$http
                .request({
                    url: "/ypt/admin/careOldPolicy/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        getRecommendPeopleList() {
            this.$http
                .request({
                    url: "/ypt/admin/BenefitsTheElderly/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        type: "1",
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            return
                        }
                        this.orgList = res.content.list.map((item) => {
                            return {
                                policyCategoryId: item.id, //id
                                policyCategoryName: item.policyCategoryName,
                            }
                        })
                    }
                })
        },
        // 操作方法
        handleTableForm(title, row) {
            this.addressInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
            this.addressSate = true
            this.manageState = false
        },
        //  导出管理
        manageVersion() {
            this.manageState = true
            this.addressSate = false
            this.manageInfo = {
                id: "",
                state: true,
            }
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.table_title {
    margin-top: 20px !important;
}

.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 12px;
    padding: 0 17px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>